import { tw } from "~/utilities/styles";

type Props = {
  score?: number;
  className?: string;
};

export function Score({ score, className = "" }: Props) {
  if (typeof score !== "number") {
    return null;
  }

  const color =
    score >= 80
      ? tw`bg-success/10 text-success`
      : score >= 50
        ? tw`bg-warn/10 text-warn`
        : tw`bg-error/10 text-error`;

  return (
    <div
      className={`flex h-10 w-full items-center justify-center rounded ${color} ${className}`}
    >
      {score.toFixed(0)}%
    </div>
  );
}
